<h1 class="title">Project pricing</h1>
<h5>&nbsp;</h5>

<acabim-card
        [cardContent]="projectPricing"
        [isCollapsible]="true"
        [isCollapsed]="false"
        [hasHelpButton]="true"
        helpMessage="Automated project subscription pricing calculations"
        cardHeading="Project Subscription Pricing Calculations">
</acabim-card>

<!-- Design Computations !-->
<ng-template #projectPricing>
    <p-tabView orientation="right">
        <p-tabPanel header="ACALand">
            <ng-template [ngTemplateOutlet]="acalandPricing">
            </ng-template>
            <div class="p-col-12">
                <button class="cas-button-non-action" (click)="calcAcalandPricing()">Calc</button>
                <button class="cas-button-non-action" (click)="initForm()">Reset</button>
            </div>
        </p-tabPanel>
        <p-tabPanel header="ACADesign">
            <ng-template [ngTemplateOutlet]="acadesignPricing">
            </ng-template>
            <div class="p-col-12">
                <button class="cas-button-non-action" (click)="calcAcadesignPricing()">Calc</button>
                <button class="cas-button-non-action" (click)="initForm()">Reset</button>
            </div>
        </p-tabPanel>
        <p-tabPanel header="ACAFM">
            <ng-template [ngTemplateOutlet]="acafmPricing">
            </ng-template>
            <div class="p-col-12">
                <button class="cas-button-non-action" (click)="calcAcafmPricing()">Calc</button>
                <button class="cas-button-non-action" (click)="initForm()">Reset</button>
            </div>
        </p-tabPanel>
    </p-tabView>
</ng-template>

<ng-template #acalandPricing>
    <form [formGroup]="acalandPricingForm" id="acalandPricingForm">
        <div class="cas-flex-row">
            <acabim-form-block labelWidth="9" [labelAlign]="'left'" class="col-md-8" [shortFields]="false" [colonize]="true">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Project type:</acabim-form-input-label>
                    <acabim-form-input-content>
                        <span>
                            <div>
                                <p-dropdown
                                        appendTo="body"
                                        formControlName="acalandProjectType"
                                        [options]="acalandProjectDataSet"
                                        optionLabel="key"
                                        placeholder="Select project type">
                                </p-dropdown>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Land size</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="landSize"/>
                                <span class="cas-form-units">sqm</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Development cost</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="developmentCost"/>
                                <span class="cas-form-units"></span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Development fee</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="consultantFee"/>
                                <span class="cas-form-units"></span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Tangible savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="tangibleSaving"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Intangible savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="intangibleSaving"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Share of savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="shareOfSavings"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Project Subscription</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="acalandProjectPricing"/>
                                <span class="cas-form-units">$/pa</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
        </div>
    </form>
</ng-template>

<ng-template #acadesignPricing>
    <form [formGroup]="acadesignPricingForm" id="acadesignPricingForm">
        <div class="cas-flex-row">
            <acabim-form-block labelWidth="9" [labelAlign]="'left'" class="col-md-8" [shortFields]="true" [colonize]="true">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Project type:</acabim-form-input-label>
                    <acabim-form-input-content>
                        <span>
                            <div>
                                <p-dropdown
                                        appendTo="body"
                                        formControlName="acadesignProjectType"
                                        [options]="acadesignProjectDataSet"
                                        optionLabel="key"
                                        placeholder="Select project type">
                                </p-dropdown>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>GFA</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="gfa"/>
                                <span class="cas-form-units">sqm</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Construction Cost</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="constructionCostPa"/>
                                <span class="cas-form-units">$/sqm</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Design fees</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="consultantFee"/>
                                <span class="cas-form-units"></span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Tangible savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="tangibleSaving"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Intangible savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="intangibleSaving"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Share of savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="shareOfSavings"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Project Subscription</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="acadesignProjectPricing"/>
                                <span class="cas-form-units">$/pa</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
        </div>
    </form>
</ng-template>

<ng-template #acafmPricing>
    <form [formGroup]="acafmPricingForm" id="acafmPricingForm">
        <div class="cas-flex-row">
            <acabim-form-block labelWidth="9" [labelAlign]="'left'" class="col-md-8" [shortFields]="true" [colonize]="true">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Project type:</acabim-form-input-label>
                    <acabim-form-input-content>
                        <span>
                            <div>
                                <p-dropdown
                                        appendTo="body"
                                        formControlName="acafmProjectType"
                                        [options]="acafmProjectDataSet"
                                        optionLabel="key"
                                        placeholder="Select project type">
                                </p-dropdown>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Total UFA</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="ufa"/>
                                <span class="cas-form-units">sqm</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>MC as % of RV</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="mcprav"/>
                                <span class="cas-form-units">sqm</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>RAV per sqm</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="ravpa"/>
                                <span class="cas-form-units">$/sqm</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>RAV</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="rav"/>
                                <span class="cas-form-units">$</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>MC</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="mc"/>
                                <span class="cas-form-units">$</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Tangible savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="tangibleSaving"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Intangible savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="intangibleSaving"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Share of savings</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="shareOfSavings"/>
                                <span class="cas-form-units">%</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
                <acabim-form-input-wrapper>
                    <acabim-form-input-label>Project Subscription</acabim-form-input-label>
                    <acabim-form-input-content [exShortField] = "true" [numeric]="false">
                        <span>
                            <div>
                                <input type="text" formControlName="acafmProjectPricing"/>
                                <span class="cas-form-units">$/pa</span>
                            </div>
                        </span>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
        </div>
    </form>
</ng-template>
